const ConfigurationHeaderComponent = () => {
  return (
    <div className="px-3 my-3 bg-white rounded-md items-center">
      <div className="py-[9px] border-b flex-col flex">
        <div className="px-3 h-10 justify-between items-center flex">
          <div className="text-black text-base font-semibold leading-tight">Configurations</div>
        </div>
      </div>
    </div>
  );
};

export default ConfigurationHeaderComponent;
